module.exports = __webpack_public_path__ + "img/KI.bb1fe376.png";